import { Box, Typography, SVGIcon, IconButton, KeyboardArrowRightIcon } from "src/components";
import { handbookGroups } from "src/data";
import { useIsMobile } from 'src/hooks';

export default function ChaptersTab({ handleCategoryClick }) {

  const isMobile = useIsMobile();

  return (
    <Box>
      {handbookGroups.map((group, i) => (
        <Box key={i} sx={{ mb: 4 }}>
          {/* Group Heading */}
          <Typography
            variant="h5"
            fontWeight={600}
            sx={{ mb: 1.5, color: "text.primary" }}
          >
            {group.title}
          </Typography>

          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              overflow: "hidden",
              mt: 2
            }}
          >
            {group.categories.map((cat, index) => (
              <Box
                key={index}
                onClick={() => {
                  if (!cat.disabled) handleCategoryClick(cat.slug)
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 1.5,
                  py: 0.5,
                  cursor: cat.disabled ? "default" : "pointer",
                  backgroundColor: "background.paper",
                  transition: "background 0.2s",
                  borderTop:
                    index === 0 ? "none" : "1px solid",
                  borderColor: "divider",
                  opacity: cat.disabled ? 0.6 : 1,
                  "&:hover": cat.disabled
                  ? {}
                  : {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                {/* Icon */}
                <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
                    <SVGIcon icon={cat.icon} size={isMobile ? 40 : 30} />
                </Box>

                {/* Title */}
                <Typography variant={isMobile ? "subtitle1" : "body2"} fontWeight={500} sx={{ flexGrow: 1 }}>
                    {cat.title}
                </Typography>

                {/* Chevron */}
                <IconButton size="small" sx={{ color: "text.secondary" }}>
                    <KeyboardArrowRightIcon fontSize={isMobile ? "small" : "inherit"} />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
